// extracted by mini-css-extract-plugin
export default {"iconOpenAndCloseDrawer":"style_iconOpenAndCloseDrawer__9vHBI","drawerContainer":"style_drawerContainer__wdHGi"};